"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartListItems = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var date_fns_1 = require("date-fns");
var singleSmartDate_1 = require("../singleSmartDate");
var StyledSmart_1 = require("../StyledSmart");
var DatePickerValidationFunctions_1 = require("../DatePickerValidationFunctions");
exports.SmartListItems = function (_a) {
    var startDate = _a.startDate, maxDate = _a.maxDate, minDate = _a.minDate, onStartDateChange = _a.onStartDateChange;
    var dateNow = new Date();
    var options = Object.values(singleSmartDate_1.SingleSmartDateTypeOptions);
    var _b = react_1.useState(''), selected = _b[0], setSelected = _b[1];
    var smartDateListItems = options.map(function (type) {
        var _a;
        var value = ((_a = singleSmartDate_1.singleSmartDates.get(type)) === null || _a === void 0 ? void 0 : _a.startDate) || dateNow;
        var isSelected = selected === type && date_fns_1.isSameDay(startDate, value);
        var disabled = !DatePickerValidationFunctions_1.isBetweenMaxMin(value, maxDate, minDate);
        var onClick = function () {
            var _a;
            setSelected(((_a = singleSmartDate_1.singleSmartDates.get(type)) === null || _a === void 0 ? void 0 : _a.name) || '');
            onStartDateChange(value);
        };
        return (react_1.default.createElement(StyledSmart_1.StyledSelectableListItem, { key: type, "data-testid": type, onClick: onClick, label: react_1.default.createElement(StyledSmart_1.SelectableListItemText, null, type), isSelected: isSelected, disabled: disabled }));
    });
    return react_1.default.createElement(react_1.default.Fragment, null, smartDateListItems);
};
